<template>
  <div style="clear:both;">
    <v-container>
      <label>Select communities to override Display Names</label>
      <v-data-table :headers="tableHeaders" :items="communities"> 
        <template v-slot:item="props">
          <tr>
            <td>
              {{ props.item.communityName }} - {{ props.item.communityAbbreviation }}
            </td>
            <td>
              <v-switch color="black" v-model="props.item.isOverridden"></v-switch>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-btn @click="saveOverrides">Save</v-btn>
    </v-container>
    
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import AdminService from '@/services/admin.service'
import Toaster from '@/components/Toaster'
export default {
  name: 'DisplayNameOverride',
  components: {
    Toaster
  },
  data: () => ({
    tableHeaders: [
      { title: 'Community Name (Abbreviation)', key: 'communityName'},
      { title: 'Is Overridden', key: 'communityName'},
    ],
    communities: []
  }),
  methods: {
    saveOverrides(){
      let payload = []
      for(let community of this.communities){
        if(community.isOverridden){
          payload.push({communityAbbreviation: community.communityAbbreviation, isOverridden: true})
        }
      }
      this.$store.dispatch('overrides/setCommunityOverrides', payload)
      this.$refs.toaster.pop('success', 'Saved Successfully')
    }
  },
  created() {
    AdminService.getCommunity()
      .then(data => {
        // TODO: match data with overrides in vue.$store
        let storeData = this.$store.state.overrides.communityOverrides
        let commData = []
        for(let community of data){
          let value = storeData.find(o => o.communityAbbreviation === community.communityAbbreviation)
          commData.push({communityName: community.communityName, communityAbbreviation: community.communityAbbreviation, isOverridden: value ? value.isOverridden : false})
        }
        this.communities = commData
      })
      .catch(err => {console.log(err)})
  }
}
</script>

<style scoped></style>